import React from 'react';
import { Data, LocationInfo } from '../../types';
import * as LocationManager from '../domain/location-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { useData, dataFromDataset } from './DataProviderCache';

type ContextState = Data<
    Array<{
        locationId: string;
        locationName: string;
        alarmCount: number;
        siteCount: number;
    }>
>;

const Context = React.createContext<ContextState | null>(null);

function useLocationAlarmList(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('uselocationListData must be used within a LocationListProvider');
    }
    return contextState;
}

const LocationListProvider: React.FC<{
    locationList: LocationInfo[];
    organizationId: string;
}> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'location-list',
        id: props.organizationId,
        dataFn: React.useCallback(
            () => LocationManager.getLocationListWithAlarm(authHelper, props.locationList),
            [authHelper, props.locationList]
        ),
    });

    const locationAlarmData = dataFromDataset(dataset);

    return <Context.Provider value={locationAlarmData}>{props.children}</Context.Provider>;
};

export { LocationListProvider, useLocationAlarmList };
